<template>
<div class="chapter">
<div class="inner_page">
<div class="figure">
<img alt="Sword of the Lamb (Book One of The Phoenix Legacy)" src="Images/cover_9203.png"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title_page.vue?601e58bd